import "./index.css";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const MyCheckbox = ({
  value = false,
  setValue = () => {},
  title = "",
  disable = false,
}) => {
  return (
    <FormControlLabel
      value="start"
      control={
        <Checkbox
          disabled={disable}
          checked={value}
          onChange={setValue}
          color="primary"
        />
      }
      label={title}
      labelPlacement="end"
    />
  );
};

export default MyCheckbox;
